/* 甘寧傳・第 2 章：夷陵（建安十三年冬，208）
 * 夷陵是江北的小城：方城四門，南邊是長江。甘寧從東邊的路進城；曹仁的兵圍在城外，北面、西面、東面各起高樓，往城裡放箭。 */
export const CITY = { x: 3800, y: 2200, hw: 900, hh: 600 };
const T = 34, G = 130, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { n: [CITY.x, N], s: [CITY.x, S], w: [Wx, CITY.y], e: [E, CITY.y] };
// 高樓（城外，看得到城裡）；城裡守兵的位置；曹兵登城的地方（城牆內側）
export const TOWERS = [[3300, N - 260], [4350, N - 260], [Wx - 280, CITY.y + 120], [E + 280, CITY.y - 160]];
export const POSTS = [[3300, N + 160], [4300, N + 160], [Wx + 160, CITY.y - 250], [Wx + 160, CITY.y + 280], [E - 160, CITY.y + 260], [E - 160, CITY.y - 280], [3500, S - 160], [4150, S - 160]];
export const CLIMB = [[3550, N + 70], [4100, N + 70], [Wx + 70, CITY.y + 60], [E - 70, CITY.y + 60], [3250, S - 70], [4350, S - 70]];
const h = (y: number) => [[(Wx + CITY.x - G) / 2, y, (CITY.x - G - Wx) / 2 + T, T], [(CITY.x + G + E) / 2, y, (E - CITY.x - G) / 2 + T, T]];
const v = (x: number) => [[x, (N + CITY.y - G) / 2, T, (CITY.y - G - N) / 2], [x, (CITY.y + G + S) / 2, T, (S - CITY.y - G) / 2]];
export default {
  id: 'ganning_yiling', name: '夷陵', W: 7600, H: 5000, seed: 2081,
  bases: [[6700, 2200], [CITY.x, CITY.y]],
  walls: [...h(N), ...h(S), ...v(Wx), ...v(E)],
  rivers: [{ pts: [[-100, 4250], [3000, 4200], [6000, 4280], [7700, 4230]], hw: 420, fords: [] }],
  roads: [
    { pts: [[7300, 2200], GATES.e, [CITY.x, CITY.y], GATES.w, [500, 2200]], w: 120 },
    { pts: [[CITY.x, 500], GATES.n, [CITY.x, CITY.y], GATES.s, [CITY.x, 3600]], w: 110 },
  ],
  rocks: [[1300, 900, 380, 170], [6300, 900, 380, 170], [1300, 3400, 380, 170], [6200, 3500, 380, 170]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[CITY.x, CITY.y, 1350], [6700, 2200, 450], [CITY.x, 700, 500], [1700, 2200, 400], [5900, 2200, 400]],
  villages: [{ x: CITY.x - 420, y: CITY.y - 60, n: 4, r: 200 }, { x: CITY.x + 420, y: CITY.y + 60, n: 4, r: 200 }],
  tents: [{ x: CITY.x, y: 700, n: 9, r: 520, chief: true, col: '#3b5a99', flag: '曹' }, { x: 1700, y: 2200, n: 4, r: 300, col: '#3b5a99' }, { x: 5900, y: 2200, n: 4, r: 300, col: '#3b5a99' }],
};
